/**
 * @prettier
 */
export function addRestaurantGoogleAnalytics(googleAnalyticsId: string): void {
    const head = document.getElementsByTagName('head')[0];
    const script1 = document.createElement('script');
    script1.async = true;
    script1.src = 'https://www.googletagmanager.com/gtag/js?id=' + googleAnalyticsId;

    head.appendChild(script1);

    const script2 = document.createElement('script');
    script2.text = `
        try {
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
        
            gtag('config', ${googleAnalyticsId});
        }catch(e){ console.log(e) }
       
    `;

    head.appendChild(script2);
}
